var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'cantidades-actuales')?_c('div',[_c('table-component',{attrs:{"models":_vm.models,"properties":_vm.properties,"show_actualizado":false,"loading":_vm.loading,"model_name":"article"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }